import { useAppContext } from "../../context/MainContext/AppContext";
import { useState } from "react";
import ProfileDropdown from "./ProfileDropdown";
import { refereeLinks, assignerLinks } from "../../utils/LinkData";
import HeaderLink from "./HeaderLink";
import HeaderDropdown from "./HeaderDropdown";
import { Role } from "../../context/MainContext/Constants";
import Sidebar from "../../components/Sidebar";
import { getPhotoFromDbUser, handleImageError } from "../../utils/Utils";

const NAV_BG   = "#1a3a4a";
const NAV_SUB  = "#162e3d";
const BORDER   = "rgba(255,255,255,0.08)";

const RefereeHeader = () => {
    const { database_user, role, setCurrentOrganization, currentOrganization } = useAppContext();
    const [showProfileModal, setShowProfileModal] = useState(false);

    const organizationOptions = Object.entries(
        database_user.Organizations || {}
    ).map(([, org]) => ({
        name: org.Name,
        payload: org.OID,
    }));

    return (
        <div className="self-stretch flex flex-col items-start justify-start font-outfit" style={{ borderBottom: `1px solid ${BORDER}` }}>
            {/* Top bar */}
            <div
                style={{ background: NAV_BG }}
                className="self-stretch flex flex-row items-center justify-between py-3 px-5"
            >
                <img
                    className="relative w-[6rem] h-[2.8rem] overflow-hidden shrink-0"
                    alt="RefAlign"
                    src="/logo.svg"
                />
                <div className="flex-1" />

                {/* Profile button */}
                <div
                    style={{
                        background: "rgba(0,201,167,0.1)",
                        border: "1px solid rgba(0,201,167,0.25)",
                        color: "#e8f0f4",
                    }}
                    className="flex flex-row items-center gap-2 px-3 py-2 rounded-xl cursor-pointer hover:bg-opacity-20 transition-all relative"
                    onClick={() => setShowProfileModal(!showProfileModal)}
                >
                    <img
                        className="rounded-full w-7 h-7 object-cover"
                        alt="User Profile"
                        src={getPhotoFromDbUser(database_user)}
                        onError={handleImageError}
                    />
                    <span className="text-sm font-medium hidden sm:block" style={{ color: "#e8f0f4" }}>
                        {database_user.Name}
                    </span>
                    <img
                        className="w-4 h-4 opacity-60"
                        alt=""
                        src="/arrowdownyellow.svg"
                    />
                </div>

                {showProfileModal && (
                    <ProfileDropdown
                        setShowProfileModal={setShowProfileModal}
                        showProfileModal={showProfileModal}
                    />
                )}
            </div>

            {/* Nav sub-bar */}
            <div
                style={{ background: NAV_SUB, borderTop: `1px solid ${BORDER}` }}
                className="self-stretch flex flex-row items-center justify-between py-1.5 px-5"
            >
                <div className="hidden lg:flex flex-row items-center gap-1">
                    {role === Role.Referee
                        ? refereeLinks.map((link, i) => <HeaderLink key={i} {...link} />)
                        : assignerLinks.map((link, i) => <HeaderLink key={i} {...link} />)}
                </div>

                <div className="block lg:hidden">
                    <Sidebar />
                </div>

                {role === Role.Assigner && (
                    <HeaderDropdown
                        options={organizationOptions}
                        selectedOption={currentOrganization}
                        setSelectedOption={setCurrentOrganization}
                    />
                )}
            </div>
        </div>
    );
};

export default RefereeHeader;
